import { toast } from 'sonner'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Удаление отменило загрузку ролика (`aborted`), а сервер отказал (`!removed`): блок/урок
 *  остался, ролика нет. Без слова автор ждал бы заливку, которой уже нет. */
export const toastIfUploadLost = (aborted: boolean, removed: boolean, kind: 'block' | 'lesson') => {
  if (!aborted || removed) return
  const m = messagesNow(messages)
  toast.error(kind === 'block' ? m.videoUploadCancelledBlockKept : m.videoUploadCancelledLessonKept)
}
